import * as React from 'react';
import {createFileRoute, useRouter} from '@tanstack/react-router';
import { Alert, AlertTitle, AlertDescription } from '@/components/atoms/alert.tsx';
import { getAccountOrders, fetchCustomerDetails } from '@/services.ts';
import { ErrorComponent } from '@/components/molecules/ErrorComponent.tsx';
import { MyDetails } from '@/components/molecules/MyDetails.tsx';
import { OrdersList } from '@/components/molecules/OrdersList.tsx';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { ACCOUNT_STALE_TIME_5_MINS } from '@/config';
import { LoadingScreen } from '@/components/molecules/LoadingScreen.tsx';

const accountHomeQueryOptions = (isServer: boolean) => queryOptions({
  queryKey: ['account', 'home'],
  queryFn: async () => {
    const customer = await fetchCustomerDetails();
    const orders = await getAccountOrders();
    if(isServer) {
      return { customer: null, orders: null }
    }
    return { customer, orders };
  },
  retry: false,
  staleTime: ACCOUNT_STALE_TIME_5_MINS,
});

export const Route = createFileRoute('/account/home')({
  loader: async ({ context }) => {
    return context.queryClient?.ensureQueryData(accountHomeQueryOptions(context.isServer));
  },
  pendingComponent: LoadingScreen,
  component: AccountHome,
  errorComponent: ErrorComponent,
});

function AccountHome() {
  const route = useRouter();
  const { data, error } = useSuspenseQuery(accountHomeQueryOptions(route.isServer));

  if(error) {
    return(<ErrorComponent error={error} />)
  }
  if(data && data.orders && data.customer) {
    const { customer, orders } = data;
    const getCustomerName = () =>  customer?.name || '';
    return(
      <div className="mt-8">
        <h1 className="text-3xl font-bold mb-4">
          Account Home
        </h1>
        <Alert>
          <AlertTitle>Hello {getCustomerName()}</AlertTitle>
          <AlertDescription>From your account dashboard, you can view your recent orders, manage your shipping and billing addess and edit your details and login password.</AlertDescription>
        </Alert>
        <div className="mt-20 space-y-8">
          <h3 className="section-title">Recent Orders</h3>
          <OrdersList orders={orders} />
          <h3 className="section-title">My Details</h3>
          <MyDetails customer={customer} />
        </div>
      </div>
    )
  }
}
